import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import OnboardingPlannerViewSectionHeader
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Components/OnboardingPlannerViewSectionHeader';
import { useOnboardingPlannerViewSectionContext } from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Sections/ViewSectionContext';
import { FDBox, FDStack } from '@facet-wealth/design';
import MoneyMindsetSubSection
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/Onboarding/Components/MoneyMindsetSubSection';

function ViewSectionLayout() {
  const {
    resource,
  } = useMetaLayoutContext();

  const {
    onAddTask,
    onAddNote,
  } = useOnboardingPlannerViewSectionContext();


  const [sectionDataResource] = resource.attr('sectionData');

  return (
    <FDStack direction={'column'} paddingX={3}>
      <OnboardingPlannerViewSectionHeader
        title={resource.attr('title')}
        onAddTask={onAddTask}
        onAddNote={onAddNote}
        size="sm"
      />
      <FDBox paddingX={1} width={'100%'}>
        <FDStack direction={'column'} spacing={4} width={'100%'}>
          {sectionDataResource.attr('moneyMindsetSubSections').resources().list().map((subSectionResource) => {
            return <MoneyMindsetSubSection resource={subSectionResource} />;
          })}
        </FDStack>
      </FDBox>
    </FDStack>
  );
}

ViewSectionLayout.propTypes = {
};

ViewSectionLayout.defaultProps = {
};

export default ViewSectionLayout;
